import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import ITOPCompass from './ReactCompass';

import DesktopBreakpoint from './responsive_utilities/desktop_breakpoint';
import TabletBreakpoint from './responsive_utilities/tablet_breakpoint';
import PhoneBreakpoint from './responsive_utilities/phone_breakpoint';
import SmallPhoneBreakpoint from './responsive_utilities/small_phone_breakpoint';

// Local Adress = 'http://localhost:5006/api/'
//const baseUrl = 'http://localhost:5006/api/';

const baseUrl = 'http://gvm.itoperators.dk:5006/api/';

export default class ItopTable extends Component {
  static propTypes = {

  };

  state = {
      /*GV1WinDir: [],*/
      GV2WinDir: [],
     /* GV3WinDir: [],*/
      GV1WinSpeed: [],
      GV2WinSpeed: [],
      GV3WinSpeed: [], 
      GV1Power: [],
      GV2Power: [],
      GV3Power: [],
      Consumer: []
    }

  componentDidMount() {
    this.fetchGeneratorData();
    this.timerID = setInterval(
      () => this.fetchGeneratorData(),
      5000
    );
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  fetchGeneratorData = async () => {

   /* let GV1WindCall = await fetch(baseUrl + 'GVM/1', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'WindDirection' }});*/
    let GV2WindCall = await fetch(baseUrl + 'GVM/2', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'WindDirection' }});
   /* let GV3WindCall = await fetch(baseUrl + 'GVM/3', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'WindDirection' }});*/
    let GV1WindSpeedCall = await fetch(baseUrl + 'GVM/1', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'WindSpeed' }});
    let GV2WindSpeedCall = await fetch(baseUrl + 'GVM/2', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'WindSpeed' }});
    let GV3WindSpeedCall = await fetch(baseUrl + 'GVM/3', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'WindSpeed' }});
    let GV1PowerCall = await fetch(baseUrl + 'GVM/1', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'GridPower' }});
    let GV2PowerCall = await fetch(baseUrl + 'GVM/2', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'GridPower' }});
    let GV3PowerCall = await fetch(baseUrl + 'GVM/3', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'GridPower' }}); 
    let ConsumerCall = await fetch(baseUrl + 'consumer', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'ID': '1', 'Key': 'ConsumerRecent' }});   

     await Promise.all([/*GV1WindCall, */GV2WindCall,/* GV3WindCall,*/ GV1WindSpeedCall, GV2WindSpeedCall, GV3WindSpeedCall, GV1PowerCall, GV2PowerCall, GV3PowerCall, ConsumerCall])    
      .then(([res1, res2, res3, res4, res5, res6, res7, res8/*, res9, res10*/]) => Promise.all([res1.json(), res2.json(), res3.json(), res4.json(), res5.json(), res6.json(), res7.json(), res8.json()/*, res9.json(), res10.json()*/]))
      .then(([data1, data2, data3, data4, data5, data6, data7, data8/*, data9, data10*/]) => this.setState({
         /* GV1WinDir: data1, */GV2WinDir: data1,/* GV3WinDir: data3,*/
          GV1WinSpeed: data2, GV2WinSpeed: data3, GV3WinSpeed: data4,
          GV1Power: data5, GV2Power: data6, GV3Power: data7,
          Consumer: data8
      }));
  }


  render() {

        let gnsWindSpeed = Math.round(((this.state.GV1WinSpeed.value + this.state.GV2WinSpeed.value + this.state.GV3WinSpeed.value) / 3) * 100) / 100;
        let totalMWProduction = Math.round(((this.state.GV1Power.value + this.state.GV2Power.value + this.state.GV3Power.value)) * 100) / 100;
        /*let gnsWindDirection = Math.round(((this.state.GV1WinDir.value + this.state.GV2WinDir.value + this.state.GV3WinDir.value) / 3)*10)/10;      */  

        //let formattedValue = new Intl.NumberFormat('de-DE').format(totalMWProduction);

        const desktopAndTabletTableData = [{
        specification: 'Vindhastighed', PW1: !isNaN(this.state.GV1WinSpeed.value) ? this.state.GV1WinSpeed.value + ' m/s' : 0, 
                                        PW2: !isNaN(this.state.GV2WinSpeed.value) ? this.state.GV2WinSpeed.value + ' m/s' : 0, 
                                        PW3: !isNaN(this.state.GV3WinSpeed.value) ? this.state.GV3WinSpeed.value + ' m/s' : 0, 
                                        total: !isNaN(gnsWindSpeed) ? gnsWindSpeed + ' m/s' : 0, HF: ''}, 
        
        { specification: 'Produktion kW', PW1: new Intl.NumberFormat('de-DE').format(!isNaN(this.state.GV1Power.value) ? Math.round((this.state.GV1Power.value)*10)/10 : 0), 
                                                  PW2: new Intl.NumberFormat('de-DE').format(!isNaN(this.state.GV2Power.value) ? Math.round((this.state.GV2Power.value)*10)/10 : 0), 
                                                  PW3: new Intl.NumberFormat('de-DE').format(!isNaN(this.state.GV3Power.value) ? Math.round((this.state.GV3Power.value)*10)/10 : 0), 
                                                  total: new Intl.NumberFormat('de-DE').format(!isNaN(totalMWProduction) ? totalMWProduction : 0), 
                                                  HF: new Intl.NumberFormat('de-DE').format(!isNaN(this.state.Consumer.value) ? Math.round((this.state.Consumer.value * 1000) * 10) / 10 : 0)},
        
       /*{ specification: 'Vindretning', PW1: !isNaN(this.state.GV1WinDir.value) ? this.state.GV1WinDir.value + ' °' : 0, 
                                        PW2: !isNaN(this.state.GV2WinDir.value) ? this.state.GV2WinDir.value + ' °' : 0, 
                                        PW3: !isNaN(this.state.GV3WinDir.value) ? this.state.GV3WinDir.value + ' °' : 0, 
                                        total: !isNaN(gnsWindDirection) ? gnsWindDirection + ' °' : 0, HF: '' }*/]

        const phoneTableData = [{
        specification: 'm/s', PW1: !isNaN(this.state.GV1WinSpeed.value) ? this.state.GV1WinSpeed.value : 0, 
                                        PW2: !isNaN(this.state.GV2WinSpeed.value) ? this.state.GV2WinSpeed.value : 0, 
                                        PW3: !isNaN(this.state.GV3WinSpeed.value) ? this.state.GV3WinSpeed.value : 0, 
                                        total: !isNaN(gnsWindSpeed) ? gnsWindSpeed : 0, HF: ''}, 
        
        { specification: 'kW', PW1: new Intl.NumberFormat('de-DE').format(!isNaN(this.state.GV1Power.value) ? Math.round((this.state.GV1Power.value)) : 0), 
                                                  PW2: new Intl.NumberFormat('de-DE').format(!isNaN(this.state.GV2Power.value) ? Math.round((this.state.GV2Power.value)) : 0), 
                                                  PW3: new Intl.NumberFormat('de-DE').format(!isNaN(this.state.GV3Power.value) ? Math.round((this.state.GV3Power.value)) : 0), 
                                                  total: new Intl.NumberFormat('de-DE').format(!isNaN(totalMWProduction) ? totalMWProduction : 0), 
                                                  HF: new Intl.NumberFormat('de-DE').format(!isNaN(this.state.Consumer.value) ? Math.round((this.state.Consumer.value * 1000)) : 0)},
        
        /*{ specification: 'Vind °', PW1: !isNaN(this.state.GV1WinDir.value) ? Math.floor(this.state.GV1WinDir.value) : 0, 
                                        PW2: !isNaN(this.state.GV2WinDir.value) ? Math.floor(this.state.GV2WinDir.value) : 0, 
                                        PW3: !isNaN(this.state.GV3WinDir.value) ? Math.floor(this.state.GV3WinDir.value) : 0, 
                                        total: !isNaN(gnsWindDirection) ? Math.floor(gnsWindDirection) : 0, HF: '' }*/]

        const desktopColumns = [
          { Header: 'Specifikation', accessor: 'specification', width: 170 }, 
          { id: 'PW1', Header: 'Mølle 1', accessor: d => d.PW1, width: 95 }, 
          { id: 'PW2', Header: 'Mølle 2', accessor: d => d.PW2, width: 95 }, 
          { id: 'PW3', Header: 'Mølle 3', accessor: d => d.PW3,  width: 95 }, 
          { id: 'Total', Header: 'I alt', accessor: d => d.total,  width: 95 }, 
          { id: 'HF', Header: 'Hjørring forbrug', accessor: d => d.HF, width: 140 }]


        const tabletColumns = [
          { Header: 'Specifikation', accessor: 'specification', width: 140 }, 
          { id: 'PW1', Header: 'Mølle 1', accessor: d => d.PW1, width: 100 }, 
          { id: 'PW2', Header: 'Mølle 2', accessor: d => d.PW2, width: 100 }, 
          { id: 'PW3', Header: 'Mølle 3', accessor: d => d.PW3,  width: 100 }, 
          { id: 'Total', Header: 'I alt', accessor: d => d.total,  width: 100 }, 
          { id: 'HF', Header: 'Hjørring forbrug', accessor: d => d.HF, width: 155 }]


        const phoneColumns = [
          { Header: 'Specs', accessor: 'specification', width: 60 }, 
          { id: 'PW1', Header: 'M 1', accessor: d => d.PW1, width: 60 }, 
          { id: 'PW2', Header: 'M 2', accessor: d => d.PW2, width: 60 }, 
          { id: 'PW3', Header: 'M 3', accessor: d => d.PW3,  width: 60 }, 
          { id: 'Total', Header: 'I alt', accessor: d => d.total,  width: 62 }, 
          { id: 'HF', Header: 'Forbrug', accessor: d => d.HF, width: 70 }]

        const smallPhoneColumns = [
          { Header: 'Spec', accessor: 'specification', width: 55 }, 
          { id: 'PW1', Header: 'M 1', accessor: d => d.PW1, width: 54 }, 
          { id: 'PW2', Header: 'M 2', accessor: d => d.PW2, width: 54 }, 
          { id: 'PW3', Header: 'M 3', accessor: d => d.PW3,  width: 54 }, 
          { id: 'Total', Header: 'I alt', accessor: d => d.total,  width: 63 }, 
          { id: 'HF', Header: 'Brug', accessor: d => d.HF, width: 60 }]


    return (
      <div className="table-container">
      <div className="compass-container">
            <ITOPCompass direction={!isNaN(this.state.GV2WinDir.value) ? this.state.GV2WinDir.value : 0} speed={!isNaN(gnsWindSpeed) ? gnsWindSpeed : 0 } />          
          </div>
        <DesktopBreakpoint>
          <ReactTable
            data={desktopAndTabletTableData}
            columns={desktopColumns}
            defaultPageSize={2}     
            showPagination={false}    
            resizable={ false }  
            sortable={false}  
          />
        </DesktopBreakpoint>

        <TabletBreakpoint>
          <ReactTable
            data={desktopAndTabletTableData}
            columns={tabletColumns}
            defaultPageSize={2}     
            showPagination={false}   
            resizable={ false }
            sortable={false}
          />
        </TabletBreakpoint>

        <PhoneBreakpoint>
          <ReactTable
            data={phoneTableData}
            columns={phoneColumns}
            defaultPageSize={2}     
            showPagination={false}          
            resizable={ false }
            sortable={false}
          />
        </PhoneBreakpoint>
        <SmallPhoneBreakpoint>
          <ReactTable
            data={phoneTableData}
            columns={smallPhoneColumns}
            defaultPageSize={2}     
            showPagination={false}   
            resizable={ false }  
            sortable={false}
          />
        </SmallPhoneBreakpoint>
      </div>        
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/ItopTable.js